<script lang="ts" setup>
import type { NavigationOptions } from 'swiper/types'

defineProps({
  downBtn: {
    type: Boolean,
    default: true,
  },
  slider: {
    type: Boolean,
    default: true,
  },
})

const hasCategory = useRoute().params.category !== undefined

const { getHeaderBanner, getHeaderSlides } = useNuxtApp().$banners.catalog

const collectionCode = computed(() => {
  const collectionFilter = useCatalogFilter().get('collections') as TFilterStoringOptions
  return collectionFilter?.options[0] || null
})

const banner = computed(() => {
  return getHeaderBanner(collectionCode.value) || null
})

const slides = computed(() => getHeaderSlides(collectionCode.value))
const slidesPicture = computed(() => {
  const defaultPicture = slides.value[0]?.picture
  const predictedCollectionTitle = collectionCode.value?.replace(/[^\p{L}\p{N}]/gu, ' ').toLowerCase()

  if (predictedCollectionTitle) {
    const collectionPicture = slides.value.find(slide => slide.name.toLowerCase() === predictedCollectionTitle)
    return collectionPicture?.picture || defaultPicture
  }

  return defaultPicture
})

const isSliderOpened = ref(false)

const toCatalog = () => {
  document.getElementById('catalog')?.scrollIntoView({ behavior: 'smooth' })
}

const navigation: NavigationOptions = {
  nextEl: '.slider__button_next',
  prevEl: '.slider__button_prev',
}
</script>

<template>
  <section class="catalog__main-banner main__section" v-if="banner">
    <div class="main__picture">
      <URemotePicture v-if="banner" :picture="banner.picture" />
      <UPictureBlank v-else :text="`Баннер для коллекции [${collectionCode}] не загружен`" large />
    </div>
    <a v-if="downBtn" class="catalog__down" @click="toCatalog">
      <span class="whitespace-nowrap">смотреть украшения</span>
      <svg-icon height="16" name="down-arrow" width="16" />
    </a>
    <div
      v-if="slider"
      :class="{ catalog__info_open: isSliderOpened }"
      class="catalog__info"
      @click="isSliderOpened = !isSliderOpened"
    >
      <div>
        <div class="catalog__button-img picture__img_filter">
          <URemotePicture v-if="slides.length > 0" :picture="slidesPicture" class="mix-blend-multiply" />
          <UPictureBlank v-else text="Изображение для слайда не загружено" />
        </div>
        <p class="catalog__button-title">Выбрать коллекцию</p>
      </div>
    </div>
    <div :class="{ catalog__menu_open: isSliderOpened }" class="catalog__menu">
      <div class="slider slider-collections mix-blend-multiply">
        <client-only>
          <swiper-container
            :navigation="navigation"
            :speed="800"
            class="swiper-container slider__collections"
            init
            slides-per-view="auto"
            watch-overflow
          >
            <swiper-slide v-for="slide in slides" :key="slide.name" class="slider-collections__good">
              <nuxt-link :to="slide.url" class="slider-collections__good-img">
                <URemotePicture :picture="slide.picture" />
              </nuxt-link>

              <nuxt-link :to="slide.url" class="slider-collections__good-link">{{ slide.name }}</nuxt-link>
            </swiper-slide>
          </swiper-container>
        </client-only>
        <div class="slider__navigation">
          <button class="slider__button slider__button_prev" type="button">
            <svg-icon height="20" name="left-slider" width="20" />
          </button>
          <button class="slider__button slider__button_next" type="button">
            <svg-icon height="20" name="right-slider" width="20" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
